import React from "react";

const MAX_LENGTH = 100;

export default function BlogTitleInput({ title, onTitleChange }) {
  return (
    <div className="bg-white border border-slate-100 shadow-sm rounded-3xl p-6 sm:p-8">
      <h2 className="font-bold text-lg text-slate-900 mb-1">
        Add Blog Title
      </h2>
      <p className="text-sm text-slate-500 mb-5">
        Write a catchy and clear title for your blog.
      </p>

      <input
        type="text"
        value={title}
        maxLength={MAX_LENGTH}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder="Enter Blog Title"
        className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-700 placeholder:text-slate-400 outline-none focus:ring-2 focus:ring-[#7209B7]/30 transition-all"
      />
      <p className="text-xs text-slate-400 text-right mt-2">
        {title.length}/{MAX_LENGTH}
      </p>
    </div>
  );
}
